import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SystemMessage} from '../models/system-message.model';
import {UrlService} from './url.service';

@Injectable()
export class ApplicationService {
    private BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data';
    }

    keepAlive() {
        this.http.get(this.BASE_URL + '/keepAlive').subscribe(
            () => {}
        );
    }

    // System Messages methods
    addSystemMessage(message: string, numHours: number): Observable<any> {
        const params = new HttpParams().set('numHours', numHours.toString());
        return this.http.post(this.BASE_URL + '/system/addSystemMessage', message, { params });
    }

    getActiveSystemMessages(): Observable<SystemMessage[]> {
        return this.http.get<SystemMessage[]>(this.BASE_URL + '/system/activeSystemMessages');
    }

    removeSystemMessage(systemMessageId: number): Observable<any> {
        return this.http.delete(this.BASE_URL + '/system/removeSystemMessage/' + systemMessageId);
    }

    getVisibleSystemMessages(): Observable<SystemMessage[]> {
        return this.http.get<SystemMessage[]>(this.BASE_URL + '/system/visibleSystemMessages');
    }

    dismissSystemMessage(systemMessageId: number): Observable<any> {
        return this.http.post(this.BASE_URL + '/system/dismissSystemMessage', systemMessageId);
    }
}
